import React, { useEffect } from 'react';
import { WorkflowCard } from './WorkflowCard';

interface WorkflowGridProps {
  workflows: any[];
  executions?: Record<string, any[]>;
  metrics?: Record<string, any>;
  onWorkflowClick?: (workflowId: string) => void;
  onWorkflowHover?: (workflowId: string) => void;
  onWorkflowDelete?: (workflowId: string, workflowName: string) => void;
}

export const WorkflowGrid: React.FC<WorkflowGridProps> = ({
  workflows,
  executions = {},
  metrics = {},
  onWorkflowClick,
  onWorkflowHover,
  onWorkflowDelete
}) => {

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
      {workflows.map((workflow) => {
        const workflowExecutions = executions[workflow.id] || [];
        const workflowMetrics = metrics[workflow.id];

        return (
          <WorkflowCard
            key={workflow.id}
            workflow={workflow}
            executions={workflowExecutions}
            metrics={workflowMetrics}
            onClick={onWorkflowClick}
            onHover={() => onWorkflowHover?.(workflow.id)}
            onDelete={onWorkflowDelete ? () => onWorkflowDelete(workflow.id, workflow.name || 'Unnamed Workflow') : undefined}
          />
        );
      })}
    </div>
  );
};
